import Profile from "../../components/user/profile/Profile";
import UserTemplate from "../../views/UserTemplate";

const ProfilePage = () => {
  return (
    <UserTemplate>
      <Profile />
    </UserTemplate>
  );
};

export default ProfilePage;
